export default __webpack_public_path__ + "static/media/starWhite.9d7899b9.svg";